
import smoothscroll from 'smoothscroll-polyfill'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import HrBlock from '@/components/elements/HrBlock.vue'
import { onMounted, computed, SetupContext, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { applyValidation } from '@/utils/validation'
import axios from 'axios'

export default {
  name: 'ResetComplete',

  setup(props: any) {
    const store = useStore()
    const router = useRouter()

    console.log('store', store.state)
    if (store.state.isPasswordResetToken != true) {
      router.push('/')
    }

    store.commit('setPasswordResetToken', false)
  },
  components: {
    HeadingLv2,
    Button
  }
}
